export default __webpack_public_path__ + "static/media/signup.f5de29c6.svg";